import * as Yup from 'yup';

export const LoginSchema = Yup.object().shape({
	email: Yup.string().required('Email is required').email('Email is invalid'),
	password: Yup.string()
		.required('Password is required')
		.min(2, 'Password must be at least 2 chars.'),
});